import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";

import { WarningIcon } from "fe-shared/src/components/Icons";
import { WARNING_COLOR } from "../../consts";
import { TransactionFlag, TransactionFlagLink } from "../../types";
import styles from "./FlagComments.module.scss";

const markdownLinksMapper = (
  markdownString: string,
  markdownLinks: TransactionFlagLink[],
  label: string
) => {
  return markdownString.replace(label, () =>
    markdownLinks
      .map(
        (markdownLink) =>
          `[${markdownLink.transactionNumber}](/${
            markdownLink.category === "Transaction"
              ? "transactions"
              : "transfers"
          }/${markdownLink.transactionNumber})`
      )
      .join(", ")
  );
};

interface Props {
  flags: TransactionFlag[];
}

const FlagComments = ({ flags = [] }: Props) => {
  const isList = flags.length > 1;

  return flags.length ? (
    <div className={classnames(styles.transactionFlagComment)}>
      <WarningIcon fillColor={WARNING_COLOR} />
      <div>
        {flags.map((item) => (
          <pre
            key={item.text}
            className={isList ? styles.transactionFlagCommentListItem : ""}
          >
            <ReactMarkdown
              source={markdownLinksMapper(
                item.text,
                item.links ?? [],
                "{Links}"
              )}
              renderers={{
                link: (linkProps) => (
                  <Link to={linkProps.href}>{linkProps.children}</Link>
                ),
              }}
            />
          </pre>
        ))}
      </div>
    </div>
  ) : null;
};

export default FlagComments;
